import { styled } from '@mui/material/styles'
import { FC } from 'react'
import { ReferenceField, TextField, useRecordContext, useTranslate } from 'react-admin'
import { CertificateOut, CertificateType } from '../../types/apiRequests'
import { dateFormatter } from '../../utils/dateFormatter'
import { getCommonName } from '../../utils/getCommonName'

const ObjectionTitle: FC = () => {
  const translate = useTranslate()
  const record = useRecordContext<CertificateOut>()

  return (
    <Root className={classes.root}>
      <h1 className={classes.title}>
        {translate(`resources.certificates.targetSystems.${record?.targetSystem?.toLocaleLowerCase()}`)}
        {' '}
        {translate(`resources.certificates.types.${record?.type}`)}
        {/* No "voor ''" when the hostname is missing. */}
        {getCommonName(record) && translate('resources.certificates.fields.url',
          {url: getCommonName(record)}
        )}
      </h1>
      <span className={classes.sdubTitle}>
        <ReferenceField
          source="municipalityId"
          reference="municipality"
          label="resources.certificates.fields.municipality"
          link="show"
        >
          <TextField source="organisatienNaam" />
        </ReferenceField>
        {
          record ? ` - ${translate('data.created')} ${dateFormatter(record.created)}` : ''
        }
      </span>
    </Root>
  )
}

const PREFIX = 'xxllncObjectionTitle'

const classes = {
  root: `${PREFIX}-root`,
  title: `${PREFIX}-title`,
  sdubTitle: `${PREFIX}-sdubTitle`,
}

const Root = styled('div', {
  name: PREFIX,
  overridesResolver: (_props, styles) => styles.root,
})(() => ({
  [`&.${classes.root}`]: {
    display: 'flex',
    flexGrow: 2,
    flexDirection: 'column',
  },
  [`& .${classes.title}`]: {
    fontSize: '16pt',
    margin: 0
  },
  [`& .${classes.sdubTitle}`]: {
    fontSize: '10pt',
  },
}))


export default ObjectionTitle